/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AddressResponseDto = {
    /**
     * Unique identifier for the address
     */
    id: string;
    /**
     * Type of address
     */
    addressType?: AddressResponseDto.addressType | null;
    /**
     * Unit number and street address
     */
    unitStreet: string;
    /**
     * Suburb
     */
    suburb: string;
    /**
     * City
     */
    city: string;
    /**
     * Postcode
     */
    postcode: string;
    /**
     * Country
     */
    country: string;
    /**
     * Lookup suggestion identifier from address autocomplete
     */
    lookupSuggestionId?: string | null;
};
export namespace AddressResponseDto {
    /**
     * Type of address
     */
    export enum addressType {
        BILLING_ADDRESS = 'BILLING_ADDRESS',
        BRANCH_ADDRESS = 'BRANCH_ADDRESS',
        BUSINESS_ADDRESS = 'BUSINESS_ADDRESS',
        CORRESPONDENCE_ADDRESS = 'CORRESPONDENCE_ADDRESS',
        HOME_ADDRESS = 'HOME_ADDRESS',
        OTHER = 'OTHER',
        REGISTERED_ADDRESS = 'REGISTERED_ADDRESS',
        SITE_ADDRESS = 'SITE_ADDRESS',
    }
}

